// wake-lock.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WakeLockService {
  private wakeLock: WakeLockSentinel | null = null;
  private fallbackVideo: HTMLVideoElement | null = null;
  private isUsingFallback = false;

  constructor() {}

  // Vérifier si l'API est supportée
  isSupported(): boolean {
    return 'wakeLock' in navigator;
  }

  // Activer le wake lock
  async requestWakeLock(): Promise<boolean> {
    if (!this.isSupported()) {
      console.warn('Wake Lock API non supportée sur ce navigateur');
      return false;
    }

    try {
      this.wakeLock = await navigator.wakeLock.request('screen');
      
      // Écouter les événements de release
      this.wakeLock.addEventListener('release', () => {
        console.log('Wake Lock released');
      });

      console.log('Wake Lock activé');
      return true;
    } catch (err) {
      console.error('Erreur lors de l\'activation du Wake Lock:', err);
      return false;
    }
  }

  // Désactiver le wake lock
  async releaseWakeLock(): Promise<void> {
    if (this.wakeLock) {
      await this.wakeLock.release();
      this.wakeLock = null;
      console.log('Wake Lock désactivé');
    }
  }

  // Vérifier si le wake lock est actif
  isActive(): boolean {
    return this.wakeLock !== null && !this.wakeLock.released;
  }

  // Gérer la visibilité de la page (important pour mobile)
  handleVisibilityChange(): void {
    if (document.visibilityState === 'visible' && this.wakeLock?.released) {
      // Réactiver le wake lock quand la page redevient visible
      this.requestWakeLock();
    }
  }
}